module.exports = __webpack_public_path__ + "img/top-left-corner.7d2b2de5.svg";